import React, { Fragment } from 'react';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import times from 'lodash.times';
import styled from 'styled-components/macro';

const Loader = styled(ContentLoader)`
  width: 100%;
`;

const EventsSkeletonLoader: React.FC = () => {
  const count = 3;

  return (
    <AnimatedLoadingWrapper loading={true}>
      <Loader
        width={400}
        height={90 + (count - 1) * 55}
        uniquekey="NotificationSkeleton"
      >
        <rect width="150" height="20" y="5" />
        {times(count, (idx) => (
          <Fragment key={`event-skeleton-${idx}`}>
            <rect width="368" height="50" y={40 + 55 * idx} />
          </Fragment>
        ))}
      </Loader>
    </AnimatedLoadingWrapper>
  );
};

export default EventsSkeletonLoader;
